import { app as firebaseApp } from 'firebase'
import useCloudProducts from './useCloudProducts'
import FirebaseApp from '../FirebaseApp'
import { useLocalProducts } from './useLocalProducts'
import { CloudProductsReturnType } from './CloudProductsReturnType'

export function useProducts(app: firebaseApp.App, useLocal?: boolean): CloudProductsReturnType {
  const cloud = useCloudProducts(FirebaseApp)
  const local = useLocalProducts()

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [loadingProductData, productDataError, productData] = useLocal ? local : cloud

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return [loadingProductData, productDataError, productData]
}